"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserPicker = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var _InputWithIcon = require("../../../elements/input-with-icon/InputWithIcon");
var _Option = require("../../../elements/option/Option");
var _userPickerModule = _interopRequireDefault(require("./user-picker.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var _noop = require("../../../utils/noop");
var _UserInfo = require("../user-info/UserInfo");
var _useHandleFocus = require("./hooks/useHandleFocus");
var _popover = require("@reach/popover");
var _Paper = require("../../../elements/paper/Paper");
var _handlePopoverPosition = require("../../../utils/popover/handlePopoverPosition");
var _useHandleClickOutside = require("../../../hooks/useHandleClickOutside/useHandleClickOutside");
var UserPicker = function UserPicker(_ref) {
  var users = _ref.users,
    trigger = _ref.trigger,
    className = _ref.className,
    popoverClassName = _ref.popoverClassName,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? _noop.noop : _ref$onChange,
    _ref$dataTestid = _ref['data-testid'],
    dataTestId = _ref$dataTestid === void 0 ? 'user-picker' : _ref$dataTestid,
    optionLabel = _ref.optionLabel,
    placeholder = _ref.placeholder;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    optionsFilter = _useState4[0],
    setOptionsFilter = _useState4[1];
  var popoverRef = (0, _react.useRef)(null);
  var triggerRef = (0, _react.useRef)(null);
  var inputRef = (0, _react.useRef)(null);
  var onClose = function onClose() {
    setIsOpen(false);
    setOptionsFilter('');
  };
  (0, _useHandleClickOutside.useHandleClickOutside)(isOpen, onClose, [popoverRef, triggerRef]);
  (0, _useHandleFocus.useHandleFocus)(isOpen, inputRef);
  var handleChange = function handleChange(value) {
    onChange(value);
    setIsOpen(false);
  };
  var filteredOptions = users.filter(function (user) {
    return "".concat(user.name, " ").concat(user.surname, " ").concat(user.email).toLocaleLowerCase().includes(optionsFilter.toLocaleLowerCase());
  });
  var renderDropdown = function renderDropdown() {
    return /*#__PURE__*/_react.default.createElement(_popover.Popover, {
      "data-testid": 'user-picker-popover',
      ref: popoverRef,
      targetRef: triggerRef,
      position: function position(_, popoverRect) {
        return (0, _handlePopoverPosition.handlePopoverPosition)(triggerRef, popoverRect);
      },
      className: (0, _classnames.default)(_userPickerModule.default['user-picker__popover'], popoverClassName)
    }, /*#__PURE__*/_react.default.createElement(_Paper.Paper, {
      "data-testid": "".concat(dataTestId, ".container"),
      className: _userPickerModule.default['user-picker__container']
    }, /*#__PURE__*/_react.default.createElement(_InputWithIcon.SearchInput, {
      ref: inputRef,
      containerClassName: _userPickerModule.default['user-picker__container-input'],
      className: _userPickerModule.default['user-picker__input'],
      id: "".concat(dataTestId, ".search"),
      name: "".concat(dataTestId, ".search"),
      placeholder: placeholder,
      onChange: function onChange(event) {
        return setOptionsFilter(event.currentTarget.value);
      },
      value: optionsFilter
    }), /*#__PURE__*/_react.default.createElement("ul", {
      className: _userPickerModule.default['user-picker__list']
    }, filteredOptions.map(function (user) {
      return /*#__PURE__*/_react.default.createElement(_Option.Option, {
        key: user.id,
        label: optionLabel,
        className: _userPickerModule.default['user-picker__option'],
        onClick: function onClick() {
          return handleChange(user.id);
        }
      }, /*#__PURE__*/_react.default.createElement(_UserInfo.UserInfo, {
        infoClassName: _userPickerModule.default['user-picker__option-info'],
        name: user.name,
        surname: user.surname,
        description: user.email
      }));
    }))));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_userPickerModule.default['user-picker'], isOpen && _userPickerModule.default['user-picker--open'], className),
    "data-testid": dataTestId
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _userPickerModule.default['user-picker__trigger'],
    ref: triggerRef,
    onClick: function onClick() {
      return setIsOpen(function (isOpen) {
        return !isOpen;
      });
    },
    role: "button"
  }, trigger), isOpen && renderDropdown());
};
exports.UserPicker = UserPicker;